import typeSpecificInfo from 'helpers/markups/typeSpecificInfo'
import chooseNextProperId from 'helpers/chooseNextProperId'
import { DEFAULT_SHAPE_OPTIONS, DEFAULT_WALL_OPTIONS } from 'helpers/globals'

export default function addMarkup(state, action) {
  const { overlay, markupType, copy } = action
  const { map, map: { markups, zoom } } = state
  const id = chooseNextProperId(markups.map(m => m.id))

  let strokeColor, fillColor

  if (copy) {
    strokeColor = overlay.strokeColor
    fillColor = overlay.fillColor
  } else {
    strokeColor = markupType === 'wall' ? DEFAULT_WALL_OPTIONS.strokeColor : DEFAULT_SHAPE_OPTIONS.strokeColor
    fillColor = DEFAULT_SHAPE_OPTIONS.fillColor
  }

  return Object.assign({}, state, {
    currentEntity: {
      type: markupType,
      id
    },
    map: {
      ...map,
      markups: [
        ...markups,
        {
          type: markupType,
          locked: false,
          ...typeSpecificInfo({ type: markupType, overlay, zoom }),
          strokeColor,
          fillColor,
          overlay,
          id
        }
      ]
    },
    ui: {
      ...state.ui,
      sidebarView: 'markupDetails'
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/addMarkup.js